import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';

/**
 * Get current cart data from server and load provider libraries
 */
export default defineThemeMiddleware(async ({ app, isServerProcess, store }) => {
	if (isServerProcess) {
		// Load current cart configuration from backend
		await store.dispatch('getCart');
	} else {
		// Load and initialize libraries
		await app.providersLibrary.load(store);
	}
});
